/**
 * Fetch JSON response from a provided netlify function
 * @param {string} path
 */
const fetchJsonResponse = async (path) => {
    try {
        const response = await fetch(path);
        return await response.json();
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        throw new Error(`Failed to fetch JSON response from path: ${path}. Error: ${error.message}`);
    }
};

/**
 * Constructs a query string from a filters object and a query parameters mapping object.
 *
 * @param {Object} filtersObj - The filters object where each key-value pair represents a filter.
 * @param {Object} queryParamsMappingObj - The query parameters mapping object where each key-value pair represents a mapping from the filters object key to the query parameter key.
 * @returns {string} The constructed query string.
 *
 * @example
 * // returns "param1=value1&param2=value2,value3"
 * constructFilterQuery({ filter1: 'value1', filter2: ['value2', 'value3'] }, { filter1: 'param1', filter2: 'param2' });
 */
const constructFilterQuery = (filtersObj, queryParamsMappingObj) => {
    const query = Object.entries(filtersObj)
        .filter(([, value]) => typeof value === "number" || value.length > 0) // filter empty query params
        .map(([key, value]) => {
            const mappedKey = queryParamsMappingObj[key] ?? key;
            const encodedValue = Array.isArray(value)
                ? value.map(encodeURIComponent).join()
                : encodeURIComponent(value);
            return `${mappedKey}=${encodedValue}`;
        })
        .join("&");
    return query;
};

export { fetchJsonResponse, constructFilterQuery };
